import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState } from "react";
import { Grid, makeStyles, FileUpload, Alert, Typography } from "../../..";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
var useStyles = makeStyles(function (theme) {
  return {
    success: {
      color: theme.palette.primary.main,
      margin: "26px"
    },
    form: {
      display: "flex",
      "flex-direction": "column",
      "align-items": "center"
    },
    title: {
      display: "flex",
      "align-items": "center",
      color: " rgb(250, 250, 250)"
    }
  };
});

var CertificateUpload = function CertificateUpload(_ref) {
  var s3path = _ref.s3path,
      server = _ref.server,
      franchise = _ref.franchise,
      translation = _ref.translation,
      handleCertificateUpload = _ref.handleCertificateUpload,
      props = _objectWithoutProperties(_ref, ["s3path", "server", "franchise", "translation", "handleCertificateUpload"]);

  var classes = useStyles();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showAlert = _useState2[0],
      setShowAlert = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      alert = _useState4[0],
      setAlert = _useState4[1];

  var handleOnCloseAlert = function handleOnCloseAlert() {
    setShowAlert(false);
    setAlert({});
  };

  var onUploadError = function onUploadError(err) {
    // console.log("values", err);
    setShowAlert(true);
    setAlert({
      open: true,
      title: "Certificado digital",
      status: "error",
      text: "No se ha podido subir el certificado. Para ayudarte, env\xEDanos un pantallazo de este error ".concat(err),
      submit: "De acuerdo",
      onSubmit: handleOnCloseAlert,
      onClose: handleOnCloseAlert
    });
  };

  var onUploadFinish = function onUploadFinish(values) {
    // console.log("finish", values);
    setShowAlert(true);
    setAlert({
      open: true,
      title: "Certificado digital",
      status: "success",
      text: "Tu certificado se ha subido correctamente.",
      submit: "Gracias!",
      onSubmit: handleOnCloseAlert,
      onClose: handleOnCloseAlert
    });
    handleCertificateUpload(values);
  };

  return [showAlert && /*#__PURE__*/React.createElement(Alert, alert), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.form
  }, franchise.certificate && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.title
  }, /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, {
    className: classes.success
  }), translation ? translation.certificate_exists : "Ya tienes un certificado subido correctamente. Si deseas sobreescribirlo, haz click en subir archivo"), /*#__PURE__*/React.createElement(FileUpload, {
    s3path: "".concat(franchise._id, "/cert/"),
    onUploadError: onUploadError,
    onUploadFinish: onUploadFinish,
    server: server,
    signingUrl: "s3/sign"
  }))];
};

export { CertificateUpload };